// Generated by ReScript, PLEASE EDIT WITH CARE

import * as $$Array from "../../../../../node_modules/rescript/lib/es6/array.js";
import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as Config from "../../../../Config.bs.js";
import * as $$String from "../../../../../node_modules/rescript/lib/es6/string.js";
import * as Json_encode from "../../../../../node_modules/@glennsl/bs-json/src/Json_encode.bs.js";
import * as N_RnrConfig from "../store/N_RnrConfig.bs.js";
import * as NetworkUtils from "../../../../library/utils/NetworkUtils.bs.js";
import * as Logger$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/logger/Logger.bs.js";
import * as N_RnrRepoConfig from "./N_RnrRepoConfig.bs.js";
import * as Network$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/helper-modules/response-handler/Network.bs.js";
import * as ApiUtils$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/ApiUtils.bs.js";
import * as N_RnrVernacularHelper from "../helper/N_RnrVernacularHelper.bs.js";

function fetchRnrReport(uuid, auth_token, lang) {
  var requestUrl = $$String.concat("", {
        hd: N_RnrConfig.rnr_2w_api_hostname,
        tl: {
          hd: N_RnrConfig.rnr_2w_api_path,
          tl: {
            hd: uuid,
            tl: {
              hd: N_RnrConfig.rnr_2w_report_path,
              tl: {
                hd: lang,
                tl: /* [] */0
              }
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV3(requestUrl, auth_token, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrReportResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function claimRnrReward(uuid, auth_token, lang, reward_ids) {
  var payloadString = JSON.stringify(Json_encode.object_({
            hd: [
              "reward_ids",
              $$Array.map((function (id) {
                      return id;
                    }), reward_ids)
            ],
            tl: {
              hd: [
                "status",
                "CLAIMED"
              ],
              tl: /* [] */0
            }
          }));
  var requestUrl = $$String.concat("", {
        hd: N_RnrConfig.rnr_2w_api_hostname,
        tl: {
          hd: N_RnrConfig.rnr_2w_api_path,
          tl: {
            hd: uuid,
            tl: {
              hd: N_RnrConfig.rnr_2w_claim_path,
              tl: {
                hd: lang,
                tl: /* [] */0
              }
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.putRequest(requestUrl, payloadString, auth_token, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrClaimResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnRConfig(uuid, auth_token) {
  var requestUrl = $$String.concat("", {
        hd: N_RnrConfig.rnr_2w_api_hostname,
        tl: {
          hd: N_RnrConfig.rnr_2w_api_path,
          tl: {
            hd: uuid,
            tl: {
              hd: N_RnrConfig.rnr_2w_config_path,
              tl: /* [] */0
            }
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: uuid
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV3(requestUrl, auth_token, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrConfigResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnRHomepageVernacularContent(language) {
  var getLanguagePath = N_RnrVernacularHelper.getCMSLanguageCode(language);
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getCMSUrl(undefined),
        tl: {
          hd: "/api/rnr-report",
          tl: {
            hd: "?populate[seasonal_campaign][populate]=*&populate[weekly_campaign][populate]=*&populate[points_claim_sticky_section][populate]=*&locale=" + getLanguagePath,
            tl: /* [] */0
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularCMSResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnRClaimRewardVernacularContent(language) {
  var getLanguagePath = N_RnrVernacularHelper.getCMSLanguageCode(language);
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getCMSUrl(undefined),
        tl: {
          hd: "/api/rnr-claim-reward",
          tl: {
            hd: "?populate[rnr_claim_reward][populate]=*&locale=" + getLanguagePath,
            tl: /* [] */0
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularClaimRewardCMSResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnRLoginDetailsVernacularContent(language) {
  var getLanguagePath = N_RnrVernacularHelper.getCMSLanguageCode(language);
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getCMSUrl(undefined),
        tl: {
          hd: "/api/rnr-login-activities/" + getLanguagePath,
          tl: {
            hd: "?populate=*",
            tl: /* [] */0
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularLoginDetailsCMSResponseConverter.execute, result);
                            });
                }), requestUrl);
}

function fetchRnRVideoDetailsVernacularContent(language) {
  var getLanguagePath = N_RnrVernacularHelper.getCMSLanguageCode(language);
  var requestUrl = $$String.concat("", {
        hd: Config.Env.getCMSUrl(undefined),
        tl: {
          hd: "/api/rnr-training-video",
          tl: {
            hd: "?populate[rnr_video_details][populate]=*&populate[rnr_video_details][thumbnail_image][populate]=true&populate[rnr_video_details][thumbnail_image][fields][0]=url&locale=" + getLanguagePath,
            tl: /* [] */0
          }
        }
      });
  Logger$Catalyst.trace({
        requestUrl: requestUrl
      });
  Logger$Catalyst.debug({
        payload: language
      });
  return NetworkUtils.catchPromiseError(Network$Catalyst.getRequestV2(requestUrl, undefined, undefined, undefined).then(function (result) {
                  return ApiUtils$Catalyst.resolveRepoResponse(function (param) {
                              return Curry._1(N_RnrRepoConfig.RnrVernacularVideoDetailsCMSResponseConverter.execute, result);
                            });
                }), requestUrl);
}

var RnrRepo = {
  fetchRnrReport: fetchRnrReport,
  claimRnrReward: claimRnrReward,
  fetchRnRConfig: fetchRnRConfig,
  fetchRnRHomepageVernacularContent: fetchRnRHomepageVernacularContent,
  fetchRnRClaimRewardVernacularContent: fetchRnRClaimRewardVernacularContent,
  fetchRnRLoginDetailsVernacularContent: fetchRnRLoginDetailsVernacularContent,
  fetchRnRVideoDetailsVernacularContent: fetchRnRVideoDetailsVernacularContent
};

export {
  RnrRepo ,
  
}
/* Config Not a pure module */
